import * as React from "react";
import { VolumeSetCreateForm } from "./form";

export const VolumeSetCreateInitializer: React.FC = () => {
  return <VolumeSetCreateForm />;
};
